import axios from "axios";

export const getBrevoData = async (apiKey) => {
  const brevo_cloud_function_url = "https://us-central1-causalfunnel-21.cloudfunctions.net/CF_Brevo_server";
  try {
    const response = await axios.post(brevo_cloud_function_url, {
      api_key: apiKey,
    });
    return response.data
  } catch (error) {
    throw error;
  }
};

export const getBrevoLists = async (apiKey) => {
  let headersList = {
    Accept: "application/json",
    Authorization: `Klaviyo-API-Key ${apiKey}`,
    revision: new Date().toISOString().split("T")[0],
  };
  let reqOptions = {
    url: "https://a.klaviyo.com/api/lists/",
    method: "GET",
    headers: headersList,
  };
  try {
    const response = await axios(reqOptions);
    return response.data;
  } catch (error) {
    throw error;
  }
};
